import moment from 'moment'
import Component from 'vue-class-component'
import Vue from 'vue'

/**
 * Mixin de utilidades de fecha para componentes
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export class DateMixin extends Vue {
    /**
     * Formatea un objeto de fecha de Javascript en una cadena con el formato dado
     *
     * @param date
     * @param format
     */
    public formatDate (date: Date | number, format = 'DD/MM/YYYY') {
        // Si date es un número será interpretada como una fecha UNIX
        const momentDate = typeof date === 'number'
            ? moment.unix(date)
            : moment(date)

        return momentDate.format(format)
    }

    /**
     * Convierte un objeto de fecha en una cadena con un formato que contiene
     * año, mes, día y hora en el idioma actual del sistema
     *
     * @param date
     */
    public localizedDate (date: Date) {
        return this.formatDate(date, 'LLL')
    }
}
